<template>
  <div style="width:100%;height:100%;display:flex;flex-direction:row;align-items:center; justify-content:center">
    <notes :title="'Need Review'" :modalClose="closeReview" :submit="needReview" v-if="is_note_open" />
    <notes :title="'Need Review HSE'" :modalClose="closeReviewHSE" :submit="needReviewHSE" v-if="is_note_open_head" />
    <notes :title="'Need Review'" :modalClose="closeReviewKTT" :submit="needReviewKTT" v-if="is_note_open_ktt" />
    <notes :title="'Reject'" :modalClose="closeReject" :submit="reject" v-if="is_reject_open" />
    <div class="kplh-approval-container">
      <kplh-template :qr_active="status == 21" :kplh="kplh" :penilaian="penilaian" :kbli="kbli"
        :bidang_usaha_gems="bidang_usaha_gems" />
      <div style="position:relative; width:100%; height:17%">
        <div class="flex-row" style="position:absolute;width:100%;border-top:1px solid gray;bottom: 10px;">
          <link-button :id="$route.params.id" :user_id="$store.state.userid" :purpose="'kplhResend'"
            v-if="status == 6 && myRequestPath && role_id == 1" />
          <link-button :id="$route.params.id" :user_id="$store.state.userid" :validation_url="'kplh-sipm-validation'"
            :purpose="'validation'" v-if="status == 8 && role_id == 1" />
          <link-button :id="$route.params.id" :user_id="$store.state.userid" :validation_url="'kplh-hse-validation'"
            :purpose="'validation'" v-if="status == 18 && role_id == 6 && checkKode()" />
          <link-button :id="$route.params.id" :user_id="$store.state.userid" :validation_url="'kplh-head-validation'"
            :purpose="'validation'" v-if="status == 19 && role_id == 7 && checkKode()" />
          <!-- <link-button
            :id="$route.params.id"
            :user_id="$store.state.userid"
            :purpose="'approveKplhHead'"
            v-if="status == 19 && role_id == 7 && checkKode()"
          />
          <link-button
            :id="$route.params.id"
            :user_id="$store.state.userid"
            :purpose="'reviewHeadHse'"
            :parentFunction="openReviewHSE"
            v-if="status == 19 && role_id == 7 && checkKode()"
          /> -->
          <link-button :id="$route.params.id" :user_id="$store.state.userid" :purpose="'approveKtt'"
            v-if="status == 20 && role_id == 13 && checkKode()" />
          <link-button :id="$route.params.id" :user_id="$store.state.userid" :purpose="'reviewKtt'"
            :parentFunction="openReviewKTT" v-if="status == 20 && role_id == 13 && checkKode()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  components: {
    TableDetail: () =>
      import('@/components/molecules/tableDetailPenilaian.vue'),
    Notes: () => import('@/components/modal/k3l/notes.vue'),
    KplhTemplate: () => import('@/components/molecules/kplh-template.vue'),
    LinkButton: () => import('@/components/Button/link-button.vue'),
  },
  data() {
    return {
      is_note_open: false,
      is_reject_open: false,
      is_note_open_head: false,
      is_note_open_ktt: false,
      fullRequest: null,
      kplh: null,
      penilaian: null,
      kbli: [],
      bidang_usaha_gems: '',
    }
  },
  async created() {
    this.getFullRequest(this.$route.params.id)
  },
  computed: {
    kode() {
      return this.$store.state.kode
    },
    role_id() {
      return this.$get(this.$store, 'state.role_id', null)
    },
    status() {
      return this.$get(this.$route, 'params.status', null)
    },
    myRequestPath() {
      return this.$route.path.indexOf('/myrequest') == -1
    },
    hseValidation() {
      return this.$route.path.indexOf('/kplh-validation-hse') == -1
    },
  },
  methods: {
    async approve() {
      try {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'POST',
          url: `${api}/api/v1/request/approve/${this.$route.params.id}`,
          data: {
            note: '',
            user_id: this.$store.state.userid,
          },
        })

        if (data && data.status == 'success') {
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          this.$store.commit('SET_NOTIF', data.message)
          this.$router.push({ path: '/approval' })
        }
      } catch (error) {

        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        this.$store.commit('SET_NOTIF', error.response.data.message)
      }
    },
    async needReviewHSE(catatan) {
      const id = this.$route.params.id
      const user_id = this.$store.state.userid
      const url = `${api}/api/v1/request/review-head-hse/${id}`

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_note_open = false
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          await this.$store.commit('SET_NOTIF', response.message)
          this.$router.push({ path: '/approval' })
        }
      } catch (error) {

        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        await this.$store.commit('SET_NOTIF', error.response.data.message)
      }
    },
    async reject(catatan) {
      const id = this.$route.params.id
      const user_id = this.$store.state.userid
      const url = `${api}/api/v1/request/reject-k3l/${id}`

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_note_open = false
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          await this.$store.commit('SET_NOTIF', response.message)
          this.$router.push({ path: '/approval' })
        }
      } catch (error) {

        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        await this.$store.commit('SET_NOTIF', error.response.data.message)
      }
    },
    openReview() {
      this.is_note_open = true
    },
    closeReview() {
      this.is_note_open = false
    },
    openReviewHSE() {
      this.is_note_open_head = true
    },
    closeReviewHSE() {
      this.is_note_open_head = false
    },
    openReject() {
      this.is_reject_open = true
    },
    closeReject() {
      this.is_reject_open = false
    },
    async needReviewKTT(catatan) {
      const id = this.$route.params.id
      const user_id = this.$store.state.userid
      const url = `${api}/api/v1/request/review-ktt/${id}`

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_note_open = false
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          await this.$store.commit('SET_NOTIF', response.message)
          this.$router.push({ path: '/approval' })
        }
      } catch (error) {

        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        await this.$store.commit('SET_NOTIF', error.response.data.message)
      }
    },
    openReviewKTT() {
      this.is_note_open_ktt = true
    },
    closeReviewKTT() {
      this.is_note_open_ktt = false
    },
    async getFullRequest(id) {
      try {
        this.$store.commit('SET_GLOBAL_LOADING', true)
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/request/full-request-kplh/${id}`,
          timeout: 300000
        })

        if (data && data.status == 'success') {
          const result = data.data
          this.kplh = result

          let bidang_usaha_gems = this.$get(
            result,
            'request.kplh_request.bidang_usaha_gems',
            '[]'
          )

          if (bidang_usaha_gems) {
            this.bidang_usaha_gems = JSON.parse(bidang_usaha_gems).map(
              item => item.JENPEK
            )
          }

          let note_1 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_ah',
            '{}'
          )
          let note_2 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_i1',
            '{}'
          )
          let note_3 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_i2',
            '{}'
          )
          let note_4 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_jm',
            '{}'
          )

          let value_1 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_ah',
            '{}'
          )
          let value_2 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_i1',
            '{}'
          )
          let value_3 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_i2',
            '{}'
          )
          let value_4 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_jm',
            '{}'
          )

          this.penilaian = {
            ...this.kplh,
            ...JSON.parse(note_1),
            ...JSON.parse(note_2),
            ...JSON.parse(note_3),
            ...JSON.parse(note_4),
            ...JSON.parse(value_1),
            ...JSON.parse(value_2),
            ...JSON.parse(value_3),
            ...JSON.parse(value_4),
          }

          if (result.request.vendor.kbli.length > 0) {
            this.kbli = result.request.vendor.kbli.map(
              item => item.kbli_sub.desc
            )
          }
          await this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
    checkKode() {
      const gems_kode =
        this.kplh && this.$get(this.kplh, 'request.gems_company', null)
      const user_kode = this.kode

      let userKodeFilter = []
      if (user_kode && user_kode.length > 0) {
        userKodeFilter = user_kode.filter(i => i.kode == gems_kode)
      }


      if (userKodeFilter.length > 0) {
        return true
      }
      return false
    },
  },
}
</script>
